// @flow

const completeUrlProtocal = (url: ?string) => {
  const HTTPS = /^https?:\/\//i;

  if (url) {
    return (HTTPS.test(url) ? url : `https://${url}`);
  }

  return '';
};

export default completeUrlProtocal;
